import React from 'react'

import { FormattedMessage } from 'react-intl'
import Popper from './Popper'
import Qrcode from '../images/webcamera_livehint.png'
import { ReactComponent as RemoteViewing } from '../images/remote-viewing.svg'
import '../styles/remoteWatchArea.scss'

export default function RemoteWatchArea({ show }) {
    const [isOpen, setOpen] = React.useState(false)
    const linkRef = React.useRef()
    if (!show) return null
    return (
        <>
            <Popper
                disablePortal
                open={isOpen}
                anchorEl={linkRef.current}
                className="remote-viewing-popper"
                placement="right"
                modifiers={{
                    offset: {
                        offset: '0,10',
                    },
                }}
            >
                <img
                    style={{ transform: 'scale(1.3)' }}
                    src={Qrcode}
                    width="84"
                    height="84"
                />
            </Popper>
            <div className="remote-viewing">
                <div className="image">
                    <RemoteViewing />
                </div>
                <div className="text">
                    <div className="title">
                        <FormattedMessage id="camera_live_hint_title" />
                    </div>
                    <div className="content">
                        <span>
                            <FormattedMessage id="camera_live_hint_text" />
                        </span>
                        <span
                            className="link"
                            onClick={(e) => {
                                if (!isOpen) {
                                    setOpen(true)
                                    window.addEventListener(
                                        'click',
                                        function () {
                                            setOpen(false)
                                            window.removeEventListener(
                                                'click',
                                                this
                                            )
                                        }
                                    )
                                    window.eventManager.sendEngagementBehavior(
                                        'show_qr_code',
                                        'preview'
                                    )
                                    e.stopPropagation()
                                }
                            }}
                            ref={linkRef}
                        >
                            <FormattedMessage id="camera_live_hint_qr" />
                        </span>
                    </div>
                </div>
            </div>
        </>
    )
}
